/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 Platz`
};

const en_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 spot`
};

const es_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 plaza`
};

const fr_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 place`
};

const it_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 posto`
};

const nl_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 plaats`
};

const pt_ev_spots__one = /** @type {(inputs: {}) => string} */ () => {
	return `1 lugar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__one = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ev_spots__one(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("ev_spots__one", locale)
	if (locale === "de") return de_ev_spots__one(inputs)
	if (locale === "en") return en_ev_spots__one(inputs)
	if (locale === "es") return es_ev_spots__one(inputs)
	if (locale === "fr") return fr_ev_spots__one(inputs)
	if (locale === "it") return it_ev_spots__one(inputs)
	if (locale === "nl") return nl_ev_spots__one(inputs)
	return pt_ev_spots__one(inputs)
};